var _defs, _polygon, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVrCone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 234.14 128.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 117.07,
    y1: 109.25,
    x2: 117.07,
    y2: 7.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2951f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2951f",
    stopOpacity: 0
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "234.14 0 117.07 117.07 0 0 234.14 0",
    fill: "url(#linear-gradient)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 117.07,
    cy: 119.29,
    r: 8.9,
    fill: "#f2951f",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.21
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrCone);
export default __webpack_public_path__ + "static/media/vr_cone.3ad8b6cba51df5dc58b1e5eba26a321b.svg";
export { ForwardRef as ReactComponent };